export enum GradingProvider {
  DankReviews = 'DankReviews',
  Sensemillier = 'Sensemillier'
}
